import React, { useState } from "react";

const ClinicianActionEditor = ({ actions = [], onChange }) => {
  const [newAction, setNewAction] = useState("");

  const handleActionChange = (index, value) => {
    const updatedActions = [...actions];
    updatedActions[index] = value;
    onChange(updatedActions);
  };

  const handleAddAction = () => {
    const value = newAction.trim();

    if (!value) return;

    onChange([...actions, value]);
    setNewAction("");
  };

  const handleDeleteAction = (index) => {
    const updatedActions = actions.filter((_, i) => i !== index);
    onChange(updatedActions);
  };

  return (
    <div className="mt-3">
      {/* <label className="form-label fw-bold">
        Clinician Actions
      </label> */}

      {actions.map((action, index) => (
        <div
          key={index}
          className="d-flex align-items-center gap-2 mb-2"
        >
          <input
            type="text"
            className="form-control"
            value={action}
            onChange={(e) =>
              handleActionChange(index, e.target.value)
            }
          />

          <button
            type="button"
            className="btn btn-sm btn-danger text-nowrap"
            onClick={() => handleDeleteAction(index)}
          >
            Delete
          </button>
        </div>
      ))}

      <div className="d-flex align-items-center gap-2 mt-2">
        <input
          type="text"
          className="form-control"
          placeholder="Enter new clinician action"
          value={newAction}
          onChange={(e) => setNewAction(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleAddAction();
            }
          }}
        />

        <button
          type="button"
          className="btn btn-sm btn-success text-nowrap"
          onClick={handleAddAction}
        >
          + New
        </button>
      </div>
    </div>
  );
};

export default ClinicianActionEditor;
